import { render, staticRenderFns } from "./IcoachSkillList.vue?vue&type=template&id=571f54ee&"
import script from "./IcoachSkillList.vue?vue&type=script&lang=ts&"
export * from "./IcoachSkillList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports